import React, { PureComponent } from 'react';
import { connect } from "react-redux";
import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const EnergyGraph = ({ appliances }) => (
            <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                    <BarChart
                        data={appliances}
                        margin={{
                            top: 5, right: 30, left: 20, bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="kwh" fill="#8884d8" />
                        <Bar dataKey="cost" fill="#82ca9d" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
);

const mapStateToProps = state => {
    return {appliances: state[0].appliances};
};

export default connect(mapStateToProps)(EnergyGraph);